var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6A0DAD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.9,274.2H56c-10,0-18.1-8.1-18.1-18.1s8.2-18.1,18.1-18.1h399.8c10.1,0,18.1,8.2,18.1,18.1 C474.1,266.1,465.9,274.2,455.9,274.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.9,147H56c-10,0-18.1-8.2-18.1-18.1s8.2-18.1,18.1-18.1h399.8c10.1,0,18.1,8.2,18.1,18.1 S465.9,147,455.9,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.9,401.4H56c-10,0-18.1-8.2-18.1-18.2c0-10,8.2-18.1,18.1-18.1h399.8c10.1,0,18.1,8.2,18.1,18.1 C474.1,393.3,465.9,401.4,455.9,401.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuActive);
export default __webpack_public_path__ + "static/media/menuActive.dfa91585838e562d05ceb5d3abda462f.svg";
export { ForwardRef as ReactComponent };